import React from "react";
import DatePickerWithMaskedInput from "../common/DatePickerWithMaskedInput";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import { titleCase } from "../../helpers/formatting";

class AccessDOB extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { dcjEnrollment } = this.props;
        if (dcjEnrollment)
            logUI("MBHWeb.UI.ProxyRequest.ProxyRequestDob.DcjEnrollment", new Date(), Tools.getURLPath());
    }

    onInputChange = (field, value, isValid) => {
        this.props.onInputChange(field, value, isValid);
    }
    handleContinueClick = (event, activeUser) => {
        const { handleValidationAndOnContinueClick, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        if (handleValidationAndOnContinueClick) {
            if (useOnboardingLayout && listOfSelectedProxyUsers?.length > 0) {
                logUI(`MBHWeb.UI.ProxyRequest.ProxyRequestDob.ProxiesActiveUser.${titleCase(activeUser)}`, new Date(), Tools.getURLPath());
            }
        this.props.handleValidationAndOnContinueClick(event);
        }
    }
    render() {
        const { validationError, dateOfBirth, validDob, dobInputId, initializeRequestData, dcjEnrollment, patientName, useOnboardingLayout, listOfSelectedProxyUsers, prefillDetails } = this.props;        
        const dateToday = new Date();
        const minDate = dateToday.setFullYear(dateToday.getFullYear() - 140); 
        const containerClass = dcjEnrollment ? "dcj-access-dob-container" : "";
        const heading = dcjEnrollment ? `Access ${patientName ? `${patientName}'s` : 'your'} health records.` : useOnboardingLayout ? "Family member's date of birth" : "Request access to a family member's health.";
        let activeUser = prefillDetails[0]?.display?.name;
        return (
            <div className={containerClass}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="step-heading step-heading-md">{heading}</h1>
                        <div className="row page-form-sm">
                            <div className="col-12">
                                {dcjEnrollment &&
                                    <h2 className="step-subheading">{`We need a little info to link your account so you can access ${patientName ? `${patientName}'s` : 'your'} care journey.`}</h2>
                                }
                                {useOnboardingLayout && (listOfSelectedProxyUsers?.length > 0 || prefillDetails[0]?.length > 0)? <div className="step-proxy-subheading">
                                    Enter <span className="step-proxy-username">{titleCase(` ${prefillDetails[0]?.display?.name}`)}'s</span> Date of Birth</div> :
                                    <h2 className="step-subheading">Please enter the date of birth for the person you are requesting access for.</h2>}
                            </div>
                        </div>
                        <div className="row page-form-sm">
                            <div className="col-12 proxy-dob">
                                <DatePickerWithMaskedInput dobId={dobInputId} required value={Tools.dateStringFormat(dateOfBirth, "MM/DD/YYYY")} yearsBackward={140} maxDate={new Date()} minDate={new Date(minDate)}
                                    onChange={(day, isValid) => {
                                        this.onInputChange('dateOfBirth',
                                            day ? Tools.dateStringFormat(day) : '', isValid);
                                    }}
                                    showAsInvalid={!validDob}
                                    placeholder="MM/DD/YYYY"
                                    dateIconNeeded={false}
                                    isMaskedDateInput
                                    onClear={initializeRequestData}
                                />
                            </div>
                            <div className="col-12">
                                <div className="footer-buttons">
                                    {
                                        (validationError !== "") &&
                                        <div className="error-msg">
                                            {validationError}
                                        </div>
                                    }
                                    {<input className="btn btn-primary" type="submit" value="Continue" onClick={(e) => this.handleContinueClick(e, activeUser)} />}
                                </div>
                            </div>                           
                            {dcjEnrollment &&
                                <div className="col-12">
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-info-filled" />
                                        </div>
                                    <div className="details-col">Approval process may take up to 1 business day.</div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        useOnboardingLayout: state.session.useOnboardingLayout,
        listOfSelectedProxyUsers: state.session.selectedProxySuggestionUsers,
    };
};
export default connect(mapStateToProps)(AccessDOB);
